import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAuthSession } from './auth/auth.providers';
import { routes } from './app.routes';
import { provideRuntimeConfig } from './core/config/runtime-config.provider';
import { provideAppStore } from './core/state/app-store.providers';
import { provideRealtimeGateway } from './realtime/realtime.providers';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideAppStore(),
    provideAuthSession(),
    provideRealtimeGateway(),
    provideRuntimeConfig(),
    provideRouter(routes)
  ]
};
